import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { usd } from "../lib/viewHold";

// Cost-first confirmation for the hold's paid buttons. Nothing is spent until the maker confirms.
export const PaidActionDialog = ({ open, title, cost, what, cancelsReview, confirmLabel, busy, onCancel, onConfirm, children }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onCancel()}>
    <AlertDialogContent data-testid="paid-action-dialog" className="rounded-3xl">
      <AlertDialogHeader>
        <AlertDialogTitle data-testid="paid-action-title">{title}</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="space-y-2 text-sm">
            {what && <p>{what}</p>}
            <p data-testid="paid-action-cost" className="font-mono2 text-foreground">
              About {usd(cost)} · counts against your allowance and hourly limits, like any paid step.
            </p>
            {cancelsReview && (
              <p data-testid="paid-action-cancels-review" className="font-semibold text-amber-700 dark:text-amber-400">
                This cancels your review request.
              </p>
            )}
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      {children}
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="paid-action-cancel" disabled={busy}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          data-testid="paid-action-confirm"
          disabled={busy}
          onClick={(e) => {
            e.preventDefault();
            onConfirm();
          }}
        >
          {busy && <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />}
          {confirmLabel} · {usd(cost)}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
